import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  description:
    "Previously we assumed specular reflections for the ray tracing method. Not the entire energy, however, is specularly reflected at the wall. This depends on the smoothness of the wall. The energy is also reflected in a diffuse manner. In its classical form it is modelled as being independent of the incidence angle, with a reflection angle ϑ based on Lambert's cosine law, with ϑ=arccos⁡√z, where z is a random number between 0 and 1.",
  theory: theory,
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "blockContainer",
        data: {
          block: {
            type: "image",
            options: {
              src: `${config.ASSETS_URL}/03/09/principle/slide-2.svg`,
            },
          },
        },
      },
    },
  },
};

export default principle;
